import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./CardHeader.module.scss";

export default function CardHeader(props) {
  const {
    className,
    children,
    color,
    plain,
    image,
    contact,
    signup,
    noShadow,
    ...rest
  } = props;
  const colorClass = color ? styles[`${color}CardHeader`] : null;
  const cardHeaderClasses = classNames(
    styles.cardHeader,
    {
      [styles.cardHeaderPlain]: plain,
      [styles.cardHeaderImage]: image,
      [styles.cardHeaderContact]: contact,
      [styles.cardHeaderSignup]: signup,
      [styles.noShadow]: noShadow,
    },
    colorClass,
    className
  );
  return (
    <div className={cardHeaderClasses} {...rest}>
      {children}
    </div>
  );
}

CardHeader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose"
  ]),
  plain: PropTypes.bool,
  image: PropTypes.bool,
  contact: PropTypes.bool,
  signup: PropTypes.bool,
  noShadow: PropTypes.bool,
  children: PropTypes.node
};
